// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t5HZ","title":"styles_title__3Yqs5"};